import { useQuery } from '@apollo/client/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EnabledCountries } from 'graphqlDocuments/queries';

export default function useCountries({ isEnabled }) {
  const { t } = useTranslation(['COUNTRIES']);
  const { data } = useQuery(EnabledCountries, {
    fetchPolicy: 'cache-first',
    variables: { isEnabled },
  });

  const countries = data?.countries;
  const options = useMemo(() => {
    if (!countries || !Array.isArray(countries)) {
      return [];
    }
    return countries
      .map((a) => ({ label: t(a.translationTag), value: a.id, ...a }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [countries, t]);

  return [options];
}
